<template>
  <div class="list-main">
    <div class="title">{{listTitle}}</div>
    <div class="main">
      <div class="area" v-if="showArea && listTitle==='基层建设'">
        <div class="title-2">
          <span :class="[{'area-hover':areaActive===1}, 'title-area']" @click="areaChoose(1)">云岩区</span>
          <span class="splice-line"></span>
          <span :class="[{'area-hover':areaActive===2}, 'title-area']" @click="areaChoose(2)">南明区</span>
          <span class="splice-line"></span>
          <span :class="[{'area-hover':areaActive===3}, 'title-area']" @click="areaChoose(3)">白云区</span>
          <span class="splice-line"></span>
          <span :class="[{'area-hover':areaActive===4}, 'title-area']" @click="areaChoose(4)">乌当区</span>
          <span class="splice-line"></span>
          <span :class="[{'area-hover':areaActive===5}, 'title-area']" @click="areaChoose(5)">花溪区</span>
          <span class="splice-line"></span>
          <span :class="[{'area-hover':areaActive===6}, 'title-area']" @click="areaChoose(6)">其他</span>
        </div>
      </div>
      <div class="single" v-for="item in articleList.data" :key="item.id">
        <div class="single-font">
          <span class="point"></span>
          <span v-if="item.external_web" class="font-title"><a :href="item.external_web" target="_blank" class="font-title">{{item.title}}</a></span>
          <span class="font-title" @click="toArticle(item.id)" v-else>{{item.title}}</span>
        </div>
        <span class="single-back">{{item.release_time}}</span>
      </div>
    </div>
    <div class="pagination">
      <el-pagination
              background
              layout="prev, pager, next, jumper"
              :page-count="articleList.total"
              :pager-count="7"
              :current-page.sync="currentPage"
              @current-change= "getNewData()"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ArticleList",
    data() {
      return {
        areaActive: 1,
        currentPage: 1
      }
    },
    props: {
      showArea: {
        type: Boolean,
        default: false
      },
      articleList: Object,
      listTitle: String
    },
    methods: {
      toArticle(id){
        let routeData = this.$router.resolve({
          path: '/article',
          query: {ArticleId: id}
        })
        window.open(routeData.href, '_blank');
      },
      areaChoose(num) {
        this.areaActive = num
        this.$emit('getAreaData', num)
      },
      getNewData() {
        this.$emit('getPage', this.currentPage)
      }
    }
  }
</script>

<style scoped lang="scss">
.list-main {
  height: 891px;
  width: 800px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: #f9f9f9;
  border: solid 1px #d9d9d9;
  border-top: solid 2px #d43e42;
  .title {
  width: 758px;
  height: 40px;
  line-height: 40px;
  font-family: 'SourceHanSerifCN-Bold';
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0;
  color: #d43e42;
  border-bottom: solid 1px #d9d9d9;
  }
  .main {
    width: 758px;
    height: 700px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .area {
      width: 500px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 20px;
      .title-2 {
        display: flex;
        width: 375px;
        margin-right: 140px;
        justify-content: space-between;
        align-items: center;
        font-family: 'SourceHanSansCN-Regular';
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0;
        color: #656565;
        .title-area {
          cursor: pointer;
        }
        .area-hover {
          color: #d43e42;
        }
        .splice-line {
          display: inline-block;
          width: 1px;
          height: 14px;
          background-color: #656565;
        }
      }
    }
    .single {
      width: 100%;
      height: 16px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-top: 20px;
      .single-font {
        height: 16px;
        width: 560px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .point {
          width: 3px;
          height: 3px;
          background-color: #282828;
        }
        .font-title {
          cursor: pointer;
          margin-left: 10px;
          max-width: 540px;
          /*height: 16px;*/
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          word-break: break-all;
          line-height: 16px;
          font-family: 'SourceHanSansCN-Regular';
          font-size: 15px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0;
          color: #282828;
        }
        .font-title:hover {
          color: #d43e42;
          border-bottom: solid 1px #d43e42;
        }
      }
      .single-back {
        min-width: 82px;
        font-family: 'SourceHanSansCN-Regular';
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0;
        color: #282828;
      }
    }
  }
  .pagination {
    margin-top: 80px;
    ::v-deep .el-pager li:not(.disabled).active {
      background-color: #e9e9e9;
      color: #000;
    }
  }
}
</style>
